module.exports = __webpack_public_path__ + "img/upct-logo.54da791f.png";